import { horizontal as o, vertical as t } from "./css/ReoTabs.mjs";
const r = {
  size: "medium",
  tabPosition: "Horizontal",
  scroll: !0,
  showLine: !0
}, s = {
  Horizontal: {
    css: o,
    name: "horizontal"
  },
  Vertical: {
    css: t,
    name: "vertical"
  }
}, a = 1;
export {
  a as TOLERANCE,
  r as defaultReoTabsProps,
  s as tabPositionConfig
};
//# sourceMappingURL=const.mjs.map
